export enum TxnType {
  Purchase = "P",
  Cash = "C",
  Refund = "R",
  Deposit = "D",
  PreAuth = "A",
  PreAuthExtend = "E",
  PreAuthTopUp = "U",
  PreAuthCancel = "Q",
  PreAuthPartialCancel = "O",
  PreAuthComplete = "L",
  PreAuthInquiry = "N",
  Void = "I",
  NotSet = " ",
  Unknown = "Unknown",
}

export enum HttpMethod {
  POST = "POST",
  GET = "GET",
}

export enum ApiType {
  Auth = "Auth",
  Pos = "Pos",
}

export enum ResponseType {
  Login = "login",
  Status = "status",
  Receipt = "receipt",
  Display = "display",
  ConfigureMerchant = "configureMerchant",
  QueryCard = "queryCard",
  ReprintReceipt = "reprintReceipt",
  Transaction = "transaction",
  Settlement = "settlement",
  Unknown = "unknown",
}

export enum ReceiptAutoPrint {
  POS = 0,
  PinPad = 9,
  Both = 7,
}

export enum HttpStatusCode {
  Unauthorized = 401,
  HttpStatusTooEarly = 425,
  ACCEPTED = 202,
  NotFound = 404,
  Timeout = 408,
}

export enum AccountType {}

export enum ErrorSource {
  Internal = "Internal",
  API = "API",
}

export enum InputType {
  None = 0,
  Normal = 1,
  Amount = 2,
  Decimal = 3,
  Password = 4,
  Unknown = "Unknown",
}

export enum GraphicCode {
  Processing = 0,
  Verify = 1,
  Question = 2,
  Card = 3,
  Account = 4,
  PIN = 5,
  Finished = 6,
  None = " ",
  Unknown = "Unknown",
}

export enum ReceiptType {
  Logon = "L",
  Customer = "C",
  Merchant = "M",
  Settlement = "S",
  ReceiptText = "R",
  Unknown = "Unknown",
}

export enum StatusType {
  //Request the EFT status from the PIN pad
  Standard = 0,
  //Not supported by all PIN pads
  TerminalAppInfo = 1,
  //Not supported by all PIN pads
  AppCpat = 2,
  AppNameTable = 3,
  Undefined = 4,
  //Request the EFT status from the PIN pad
  Preswipe = 5,
}

export enum NetworkType {
  Leased = 1,
  Dialup = 2,
  Unknown = " ",
}

export enum KeyHandlingType {
  SingleDes = 1,
  TripleDes = 2,
  Unknown = " ",
}

export enum TerminalCommsType {
  Cable = 0,
  Infrared = 1,
  Unknown = " ",
}

export enum EftTerminalType {
  IngenicoNPT710 = "IngenicoNPT710",
  IngenicoPX328 = "IngenicoPX328",
  Ingenicoi5110 = "Ingenicoi5110",
  Ingenicoi3070 = "Ingenicoi3070",
  Sagem = "Sagem",
  Verifone = "Verifone",
  Keycorp = "Keycorp",
  LinklyVirtualPinPad = "PCEFTPOSVirtualPinpad",
  Unknown = "Unknown",
}

export enum ReprintType {
  GetLast = 2,
  Reprint = 1,
}
